import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { v4 as uuidv4 } from 'uuid';
import AOS from 'aos';

import { CareerService } from '../../../services/career.service';
import { SEOService } from '../../../services/seo.service';
import { Job } from '../job.interface';

declare let fbq: any;

@Component({
  selector: 'app-open-positions',
  imports: [CommonModule, RouterModule],
  standalone: true,
  templateUrl: './open-positions.component.html',
  styleUrl: './open-positions.component.scss',
})
export class OpenPositionsComponent implements OnInit, AfterViewInit {
  @ViewChild('heroVideo') heroVideo!: ElementRef<HTMLVideoElement>;
  jobData: Job[] = [];
  filteredJobs: Job[] = [];
  locations: string[] = [];
  selectedLocation: string = '';
  private eventID = uuidv4();

  constructor(
    private _careerservice: CareerService,
    private router: Router,
    private seoService: SEOService,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient
  ) { }

  nav(url: any) {
    this.router.navigateByUrl(url);
  }

  private forcePlayHeroVideo() {
    const video = this.heroVideo?.nativeElement;
    if (!video) return;

    video.muted = true;           // required for autoplay
    video.playsInline = true;

    const play = () => {
      video.play().catch(() => {
        // retry if browser blocks
        setTimeout(() => video.play().catch(() => { }), 300);
      });
    };

    // Ensure it runs after Angular rendering
    setTimeout(play, 100);
  }

  ngOnInit(): void {
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route: { data: any; }) => route.data)
    )
      .subscribe((event: any) => {
        if (this.router.url === '/careers/open-positions') {
          this.updateDescription(event.description, event.keywords, event.title);
        }
      });

    this._careerservice.getJob().subscribe({
      next: (result: Job[]) => {
        console.log("Jobs received:", result);
        this.jobData = result;
        this.filteredJobs = result;
        this.locations = [...new Set(result.map(job => job.Location))];
      },
      error: () => {
        console.log("Invalid Request")
      }
    }
    );
  }

  // Initialize Animations
  ngAfterViewInit() {
    this.forcePlayHeroVideo();
    setTimeout(() => {
      AOS.init();
      AOS.refresh();
    }, 1000);
  }

  updateDescription(desc: string, keywords: string, title: string) {
    this.seoService.updateDescription(desc);
    this.seoService.updateMetaKeywords(keywords);
    this.seoService.updateTitle(title);
  }

  filterByLocation(event: Event): void {
    const target = event.target as HTMLSelectElement;
    if (target) {
      const location = target.value;
      this.selectedLocation = location;

      if (location === "") {
        this.filteredJobs = this.jobData;
      } else {
        this.filteredJobs = this.jobData.filter((job: Job) => job.Location === location);
      }
    }
  }

  // filterByLocation(event: Event): void {
  //   const target = event.target as HTMLSelectElement;
  //   if (target) {
  //     const location = target.value;
  //     this.selectedLocation = location;
  //     this.filteredJobs = this.jobData.filter((job: Job) => job.Location === location);
  //   }
  // }

  async submitApplication(formData: any) {
    const eventID = uuidv4();
    fbq(
      'track',
      'SubmitApplication',
      {
        content_name: formData.jobTitle,
        content_category: 'Open Positions',
        content_ids: [formData.jobId]
      },
      { eventID }
    );

    this.http.post('/api/capi/submit', {
      email: formData.email,
      jobTitle: formData.jobTitle,
      jobId: formData.jobId,
      eventID
    }).subscribe(
      () => console.log('CAPI event sent'),
      err => console.error('CAPI error', err)
    );
  }
}